// extracted by mini-css-extract-plugin
module.exports = {"summary__item":"N_dh","summary__item__name":"N_dj","summary__item__price":"N_dk","summary__col__wrap":"N_dl","summary__quantity":"N_dm"};